module.exports = "/_next/static/images/avatar-frame-tier-1--simple-0731ff7432697fd7e1be42889bfe4787.png";